import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/view/index.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/view/home.vue'),
  },
  {
    path: '/ecology',
    name: 'web3',
    component: () => import('@/view/web3.vue'),
  },
  {
    path: '/nft',
    name: 'nft',
    component: () => import('@/view/nft.vue'),
  },
  {
    path: '/swap',
    name: 'swap',
    component: () => import('@/view/swap.vue'),
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

// router.beforeEach((to, from, next) => {
//   const title = to.meta && to.meta.title;
//   if (title) {
//     document.title = title;
//   }
//   next();
// });

export {
  router
};
